import { React, useEffect, useState } from 'react';

// mui
import {
    Grid,
    Paper,
    Autocomplete,
    TableContainer,
    Table,
    TableRow,
    TableBody,
    TableCell,
    IconButton,
    Box,
    Typography,
    TextField,
} from '@mui/material';

import { Upload as UploadIcon } from '@mui/icons-material';

// components
import { getFilterStatusString, optionsFilterOptionAttribute } from '../..';

// client-shared
import { storage } from '@goldblack/client-storage';
import { ListboxComponent } from '@goldblack/client-comps';

function updateFilterOption(filterOptionId, field, data, filterOptions) {
    let found = filterOptions.data.find((type) => type._id === filterOptionId);
    let newType = { ...found };

    newType[field] = data;

    let callback = (type) => type._id === filterOptionId;
    storage.transience.updateState('loise.filterOption.data', callback, newType);
}

function AdminFilterOption(props) {
    const filterOption = storage.transience.getValue('loise.filterOption');

    const uploadOptions = (event) => {
        let reader = new FileReader();
        reader.onload = function (e) {
            let options = JSON.parse(e.target.result);
            updateFilterOption(props.filterOption._id, 'options', options, filterOption);
        };
        if (event.target.files[0]) {
            reader.readAsText(event.target.files[0]);
        }
    };

    const getOptionLabel = (option) => {
        return option.toString();
    };

    const renderOption = (props, option) => {
        return (
            <Box component='li' {...props} key={props.key}>
                <Typography sx={{ fontSize: '14px' }}>{option.toString()}</Typography>
            </Box>
        );
    };

    return (
        <Grid container spacing={0} direction='row' justifyContent='flex-start' alignItems='center'>
            <Grid size={11}>
                <Autocomplete
                    size='small'
                    sx={{ width: '100%' }}
                    options={props.filterOption.options ?? []}
                    getOptionLabel={(option) => getOptionLabel(option)}
                    defaultValue={null}
                    slotProps={{
                        listbox: {
                            component: ListboxComponent,
                        },
                        paper: {
                            variant: 'outlined',
                        },
                    }}
                    renderOption={(props, option) => renderOption(props, option)}
                    renderInput={(params) => <TextField {...params} size='small' />}
                />
            </Grid>
            <Grid size={1}>
                <IconButton color='primary'>
                    <label htmlFor={'raised-json-file' + props.index}>
                        <UploadIcon />
                    </label>
                </IconButton>
            </Grid>
            <input
                accept='application/JSON'
                hidden
                id={'raised-json-file' + props.index}
                multiple={false}
                type='file'
                onChange={uploadOptions}
            />
        </Grid>
    );
}

function AdminFilterOptionAttribute(props) {
    const filterOption = storage.transience.getValue('loise.filterOption');

    const onChangeAttribute = (event, values) => {
        const flags = values.reduce((acc, v) => acc | v.code, 0);
        updateFilterOption(props.filterOption._id, 'attributes', flags, filterOption);
    };

    const selected = optionsFilterOptionAttribute.filter((o) => (props.filterOption.attributes & o.code) !== 0);

    return (
        <Autocomplete
            sx={{ m: 0, p: 0 }}
            multiple
            options={optionsFilterOptionAttribute}
            value={selected}
            getOptionLabel={(o) => o.label}
            isOptionEqualToValue={(o, v) => o.code === v.code}
            disableCloseOnSelect
            slotProps={{
                listbox: { component: ListboxComponent },
            }}
            renderInput={(params) => <TextField {...params} size='small' />}
            onChange={onChangeAttribute}
        />
    );
}

function AdminFilterOptionName(props) {
    const filterOption = storage.transience.getValue('loise.filterOption');

    const changeName = (event) => {
        updateFilterOption(props.filterOption._id, 'name', event.currentTarget.innerText, filterOption);
    };

    return (
        <Paper
            sx={{ backgroundColor: 'background.default' }}
            suppressContentEditableWarning={true}
            contentEditable={true}
            onBlur={changeName}
            elevation={0}>
            {props.filterOption ? props.filterOption.name : ''}
        </Paper>
    );
}

function LoiseFiltersFilterOptionInfoPanel(props) {
    const [createdString, setCreatedString] = useState('');
    const [modifiedString, setModifiedString] = useState('');

    useEffect(() => {
        if (props.filterOption) {
            setCreatedString(
                props.filterOption.createdAt ? new Date(props.filterOption.createdAt).toLocaleString('ko-KR') : '',
            );
            setModifiedString(
                props.filterOption.modifiedAt ? new Date(props.filterOption.modifiedAt).toLocaleString('ko-KR') : '',
            );
        }
    }, [props.filterOption]);

    return props.filterOption ? (
        <Grid container spacing={0} justifyContent='center' alignItems='flex-start'>
            <TableContainer>
                <Table sx={{ '& td, & th': { border: 1, borderColor: 'divider' } }}>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{ width: '20%' }}>name</TableCell>
                            <TableCell sx={{ width: '80%' }} align='right'>
                                <AdminFilterOptionName {...props} />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>status</TableCell>
                            <TableCell align='right'>{getFilterStatusString(props.filterOption.status)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>attributes</TableCell>
                            <TableCell align='right'>
                                <AdminFilterOptionAttribute {...props} />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>created</TableCell>
                            <TableCell align='right'>{createdString}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>modified</TableCell>
                            <TableCell align='right'>{modifiedString}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>option</TableCell>
                            <TableCell align='right'>
                                <AdminFilterOption {...props} />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    ) : (
        <></>
    );
}

export { LoiseFiltersFilterOptionInfoPanel };
